import { InputGroup } from './styles'

export default InputGroup
